import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CustomStaicAccordianStyles {
    accordianContainer?: InjectableCss;
    bottomContent?: InjectableCss;
}

export const CustomStaicAccordianStyles: CustomStaicAccordianStyles = {
    bottomContent: {
        css: css`
            [class^="GridOffset"] {
                h2 {
                    color: #666;
                    margin-top: 30px;
                }
                [class^="GridItemStyle"] {
                    [class^="Wrapper"] {
                        [class^="Wrapper"] {
                            padding: 10px;
                            cursor: pointer;
                            width: 100%;
                            transition: all 0.8s ease 0s;
                            &:hover {
                                transform: scale(1.1);
                                [class^="ContentWrapper"] {
                                    h4 {
                                        color: #3666b1;
                                        font-size: 14px;
                                    }
                                }
                            }
                            [class^="LazyImageStyle"] {
                                img {
                                    border-radius: 50%;
                                    width: 130px;
                                    height: 130px;
                                }
                            }
                            [class^="ContentWrapper"] {
                                h4 {
                                    text-align: center;
                                    font-size: 18px;
                                    color: #666;
                                    padding: 5px 30px 0;
                                    display: inline;
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
};

const styles = CustomStaicAccordianStyles;

const CustomStaicAccordian: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.accordianContainer}>
            <Accordion headingLevel={4} aria-labelledby="listTitle" data-test-selector="CustomStaicAccordian">
                <ManagedAccordionSection title={<Zone contentId={id} zoneName="ZoneTitle" />}>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="ZoneContent" />
                    </StyledWrapper>
                </ManagedAccordionSection>
            </Accordion>
            <StyledWrapper {...styles.bottomContent}>
                <Zone contentId={id} zoneName="additionalContentBlock" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomStaicAccordian,
    definition: {
        displayName: "Custom Static Accordian",
        group: "Common",
    },
};

export default widgetModule;
